export const state = () => ({
  draggingAsset: null
})

export const mutations = {
  updateDraggingAsset (state, value) {
    state.draggingAsset = value
  }
}

export const actions = {
  setDraggingAsset({ commit }, draggingAsset) {
    commit('updateDraggingAsset', draggingAsset)
  },
  resetDraggingAsset({ commit }) {
    commit('updateDraggingAsset', null)
  }
}
